import styled from 'styled-components';

import { palette } from '~/theme';
import PlainCard from '~atoms/PlainCard';
import * as DesignSectionCardSt from '~organisms/DesignSectionCard/DesignSectionCard.styles';

export const imgClassName = 'skeleton-card--appliance--img';
export const lineClassName = 'skeleton-card--appliance--line';
export const btnClassName = 'skeleton-card--appliance--btn';

const skeletonCss: React.CSSProperties = {
  backgroundColor: `${palette.lightGray} !important`,
};

export const Container = styled(PlainCard)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignSelf: 'stretch',

  padding: DesignSectionCardSt.containerPadding,

  [`.${imgClassName}`]: {
    width: '100%',
    marginBlockEnd: '4rem',
    marginInline: 'auto',
  },
  [`.${imgClassName} > *:first-child`]: {
    ...skeletonCss,
    width: '70%',
    height: '120rem !important',
    marginInline: 'auto',
    borderRadius: '15rem !important',
  },
  [`.${imgClassName} svg`]: {
    width: '100rem !important',
    height: '100rem !important',
  },
  [`.${imgClassName} path`]: {
    fill: 'white !important',
  },

  [`.${lineClassName}`]: {
    width: '100%',
  },
  [`.${lineClassName} > *:first-child`]: {
    ...skeletonCss,
    height: '17rem !important',
    borderRadius: '0 !important',
  },
  [`.${lineClassName}:nth-child(2) > *`]: {
    marginBlockEnd: '4rem',
  },
  [`.${lineClassName}:nth-child(3) > *`]: {
    marginBlockEnd: '15rem',
  },
  [`.${lineClassName}:nth-child(4) > *`]: {
    height: '25rem !important',
    marginBlockEnd: '5rem',
  },

  [`.${btnClassName}`]: {
    marginInlineStart: 'auto',
  },
  [`.${btnClassName} > *:first-child`]: {
    ...skeletonCss,
    height: '20rem !important',
  },
});
